import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetRoles } from "../../shared/services/utilisateurs/user.service";
import { Button, Space } from "antd";
import Card from "antd/es/card/Card";

const EspaceUser: FC = () => {

    const navigate = useNavigate()

    const[isAdmin, setIsAdmin] = useState<boolean>(false);
    const[isGarde, setIsGarde] = useState<boolean>(false);
    const {dataRole, errorRole} = useGetRoles();

    useEffect(() => {
        if(errorRole){
            navigate("/connexion");
        }
    }, [errorRole])

    useEffect(() =>{
        if(dataRole){
            setIsAdmin(dataRole.some(r => r.role === "ADMIN"));
            setIsGarde(dataRole.some(r => r.role === "GARDE"));
        }
    }, [dataRole])

    function naviguerVersReservation(){
        navigate("/reservation");
    }

    function naviguerVersReservationAdmin(){
        navigate("/reservationadmin");
    }

    function naviguerVersPlanning(){
        navigate("/planning");
    }

        function naviguerVersPlanningAdmin(){
        navigate("/planningadmin");
    }

    function naviguerVersListeReservations(){
        navigate("/listereservations");
    }

    function naviguerVersListeUsers(){
        navigate("/listeusers");
    }

    return(
        <div>
            <Card title={<span style={{ textAlign: "center" }}>Bienvenue sur votre espace utilisateur</span>} variant="borderless" className="responsive-card">
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <Button type="primary"  onClick={naviguerVersReservation} style={{ marginTop: "10px", backgroundColor: "green" }}>Faire une réservation</Button>
                    <Button type="primary"  onClick={(isAdmin || isGarde) ? naviguerVersPlanningAdmin : naviguerVersPlanning} style={{ marginTop: "10px", backgroundColor: "green" }}>Voir le planning</Button>
                    <Button type="primary"  onClick={naviguerVersListeReservations} style={{ marginTop: "10px", backgroundColor: "green" }}>Mes réservations</Button>
                </Space>
            </Card>
            { isAdmin ? (
                <Card title={<span style={{ textAlign: "center" }}>Espace Administrateur</span>} variant="borderless" className="responsive-card">
                    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                        <Button type="primary"  onClick={naviguerVersListeUsers} style={{ marginTop: "10px", backgroundColor: "green" }}>Liste utilisateurs</Button>
                        <Button type="primary"  onClick={naviguerVersReservationAdmin} style={{ marginTop: "10px", backgroundColor: "green" }}>Réservation d'événement</Button>
                    </Space>
                </Card>
            ): (null)}
        </div>
    )
}

export default EspaceUser;